import React, { useState, useEffect } from "react";
import roomBackgrounds from "../assets/roomBackgrounds";

function LoginForm() {
  
useEffect(() => {
  // Set default background on mount
  document.body.style.backgroundImage = `url(${roomBackgrounds.Default})`;
  document.body.style.backgroundSize = "cover";
  document.body.style.backgroundPosition = "center";
  document.body.style.backgroundRepeat = "no-repeat";
  document.body.style.backgroundAttachment = "fixed";

  // Clear on unmount
  return () => {
    document.body.style.backgroundImage = "none";
    document.body.style.background = "black"; // fallback color
  };
}, []);

  const [form, setForm] = useState({ username: "", accessCode: "", displayName: "" });
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await res.json();
      if (res.ok && data.token) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("username", form.username);
        localStorage.setItem("displayName", form.displayName || form.username);
        window.location.href = "/rooms";
      } else {
        setMessage(`❌ ${data.error || "Login failed"}`);
      }
    } catch (err) {
      setMessage("⚠️ Server error");
    }
  };

  return (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh'  // full viewport height for vertical centering
  }}>
    <form onSubmit={handleLogin} style={{
      textAlign: 'center',
      padding: '2rem',
      border: '1px solid #ccc',
      borderRadius: '10px',
      background: 'rgba(240, 240, 240, 0.7)',
      boxShadow: '0 0 10px rgba(0,0,0,0.1)'
    }}>
      <h2>Login</h2>
      <input name="username" placeholder="Username" onChange={handleChange} required />
      <br />
      <input name="displayName" placeholder="Display Name" onChange={handleChange} />
      <br />
      <input name="accessCode" placeholder="Password" type="password" onChange={handleChange} required />
      <br />
      <button type="submit">Login</button>
      <p>{message}</p>
    </form>
  </div>
);
}

export default LoginForm;
